import React from 'react';
import { setSessionIdToUrl, showMessage, gtag_report_conversion, toggleModal, UpgradeSuccessModal } from 'h-commons';
import { PLAN_UPGRADE_DONE,CLEAR_STRIPE_SCA } from './types';

export const confirmUpgradation = (userSession,planMeta) => (dispatch) => {

    dispatch({ type: CLEAR_STRIPE_SCA });
    showMessage({
        message: 'Subscribed to new plan successfully',
        type: 'success',
        autoClose: 17000
    });
    gtag_report_conversion('upgrade');
    const handleUpgradeModal = () => {
        let refreshLink = '/app/settings/account';
        if (userSession)
            refreshLink = setSessionIdToUrl(refreshLink, userSession);
        window.location.replace(refreshLink);
    }
    dispatch(toggleModal(
        <UpgradeSuccessModal 
            planType={planMeta.type} 
            planName={planMeta.title} 
            onSubmit={handleUpgradeModal} />
    ))
    dispatch({ 
        type: PLAN_UPGRADE_DONE
    });

}